// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tim-row {
  margin-bottom: 20px;
}

.tim-white-buttons {
  background-color: #777777;
}

.typography-line {
  padding-left: 25%;
  margin-bottom: 35px;
  position: relative;
  display: block;
  width: 100%;
}

.typography-line span {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  margin-left: 20px;
  position: absolute;
  width: 260px;
  text-transform: none;
}

.tim-row {
  padding-top: 60px;
}

.tim-row h3 {
  margin-top: 0;
}

.switch {
  margin-right: 20px;
}

#navbar-full .navbar {
  border-radius: 0 !important;
  margin-bottom: 15px;
  z-index: 2;
}

#menu-dropdown .navbar {
  border-radius: 3px;
}

#pagination-row .pagination-container {
  height: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
}

#icons-row i.now-ui-icons {
  font-size: 30px;
}

.space {
  height: 130px;
  display: block;
}

.space-110 {
  height: 110px;
  display: block;
}

.space-50 {
  height: 50px;
  display: block;
}

.space-70 {
  height: 70px;
  display: block;
}

.navigation-example .img-src {
  background-attachment: scroll;
}

.navigation-example {
  background-position: center center;
  background-size: cover;
  margin-top: 0;
  min-height: 740px;
  height: 100%;
}

#notifications {
  display: block;
  width: 100%;
  position: relative;
}

.tim-note {
  text-transform: capitalize;
}

#buttons .btn,
#javascriptComponents .btn {
  margin: 0 0px 10px;
  margin-right: 4px;
}

.space-100 {
  height: 100px;
  display: block;
  width: 100%;
}

.be-social {
  padding-bottom: 20px;
  /*     border-bottom: 1px solid #aaa; */
  margin: 0 auto 40px;
}

.txt-white {
  color: #FFFFFF;
}

.txt-gray {
  color: #ddd !important;
}

.parallax {
  width: 100%;
  height: 570px;
  display: block;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.logo-container .logo {
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #333333;
  width: 50px;
  float: left;
}

.logo-container .brand {
  font-size: 16px;
  color: #FFFFFF;
  line-height: 18px;
  float: left;
  margin-left: 10px;
  margin-top: 7px;
  width: 70px;
  height: 40px;
  text-align: left;
}

.logo-container .brand-material {
  font-size: 18px;
  margin-top: 15px;
  height: 25px;
  width: auto;
}

.logo-container .logo img {
  width: 100%;
}

.navbar-small .logo-container .brand {
  color: #333333;
}

.fixed-section {
  top: 90px;
  max-height: 80vh;
  overflow: scroll;
  position: sticky;
}

.fixed-section ul {
  padding: 0;
}

.fixed-section ul li {
  list-style: none;
}

.fixed-section li a {
  font-size: 14px;
  padding: 2px;
  display: block;
  color: #666666;
}

.fixed-section li a.active {
  color: #00bbff;
}

.fixed-section.float {
  position: fixed;
  top: 100px;
  width: 200px;
  margin-top: 0;
}

.parallax .parallax-image {
  width: 100%;
  overflow: hidden;
  position: absolute;
}

.parallax .parallax-image img {
  width: 100%;
}

@media (max-width: 768px) {
  .parallax .parallax-image {
    width: 100%;
    height: 640px;
    overflow: hidden;
  }
  .parallax .parallax-image img {
    height: 100%;
    width: auto;
  }
}

/*.separator{
    content: "Separator";
    color: #FFFFFF;
    display: block;
    width: 100%;
    padding: 20px;
}
.separator-line{
    background-color: #EEE;
    height: 1px;
    width: 100%;
    display: block;
}
.separator.separator-gray{
    background-color: #EEEEEE;
}*/

.social-buttons-demo .btn {
  margin-right: 5px;
  margin-bottom: 7px;
}

.img-container {
  width: 100%;
  overflow: hidden;
}

.img-container img {
  width: 100%;
}

.lightbox img {
  width: 100%;
}

.lightbox .modal-content {
  overflow: hidden;
}

.lightbox .modal-body {
  padding: 0;
}

@media screen and (min-width: 991px) {
  .lightbox .modal-dialog {
    width: 960px;
  }
}

@media (max-width: 991px) {
  .fixed-section.affix {
    position: relative;
    margin-bottom: 100px;
  }
}

@media (max-width: 768px) {
  .btn,
  .btn-morphing {
    margin-bottom: 10px;
  }
  .parallax .motto {
    top: 170px;
    margin-top: 0;
    font-size: 60px;
    width: 270px;
  }
}

/*       Loading dots  */

/*      transitions */

.presentation .front,
.presentation .front:after,
.presentation .front .btn,
.logo-container .logo,
.logo-container .brand {
  transition: all .2s;
}

#images h4 {
  margin-bottom: 30px;
}

#javascriptComponents {
  padding-bottom: 0;
}

/*      layer animation          */

.layers-container {
  display: block;
  margin-top: 50px;
  position: relative;
}

.layers-container img {
  position: absolute;
  width: 100%;
  height: auto;
  top: 0;
  left: 0;
  text-align: center;
}

.animate {
  transition: 1.5s ease-in-out;
  -moz-transition: 1.5s ease-in-out;
  -webkit-transition: 1.5s ease-in-out;
}

.navbar-default.navbar-small .logo-container .brand {
  color: #333333;
}

.navbar-transparent.navbar-small .logo-container .brand {
  color: #FFFFFF;
}

.navbar-default.navbar-small .logo-container .brand {
  color: #333333;
}

.sharing-area {
  margin-top: 80px;
}

.sharing-area .btn {
  margin: 15px 4px 0;
}

.section-thin,
.section-notifications {
  padding: 0;
}

/*.section-navbars{
    padding-top: 0;
}*/

#navbar .navbar {
  margin-bottom: 20px;
  z-index: 1 !important;
}

#navbar .navbar-toggler,
#menu-dropdown .navbar-toggler {
  pointer-events: none;
}

.section-pagination {
  padding-bottom: 0;
}

.section-pagination .pagination:last-of-type {
  margin-bottom: 7px;
}

.section-download {
  padding-top: 130px;
}

.section-download .description {
  margin-bottom: 60px;
}

.section-download h4 {
  margin-bottom: 25px;
}

.section-examples a {
  text-decoration: none;
}

.section-examples a+a {
  margin-top: 30px;
}

.section-examples h5 {
  margin-top: 30px;
}

.components-page .wrapper>.header,
.tutorial-page .wrapper>.header {
  height: 500px;
  padding-top: 128px;
  background-size: cover;
  background-position: center center;
}

.components-page .title,
.tutorial-page .title {
  color: #FFFFFF;
}

.brand .h1-seo {
  font-size: 5em;
  text-transform: uppercase;
  font-weight: 300;
}

.brand .n-logo {
  max-width: 100px;
  margin-bottom: 40px;
}

.invision-logo {
  max-width: 70px;
  top: -2px;
  position: relative;
}

.creative-tim-logo {
  max-width: 140px;
  top: -2px;
  position: relative;
}

.section-javascript .title {
  margin-bottom: 0;
}

.navbar .switch-background {
  display: block;
}

.navbar-transparent .switch-background {
  display: none;
}

.section-signup .col .btn {
  margin-top: 30px;
}

#buttons-row .btn {
  margin-bottom: 10px;
}

.section-images {
  padding-bottom: 0;
}

@media screen and (max-width: 991px) {
  .section-navbars .navbar-collapse {
    display: none !important;
  }
}

@media screen and (max-width: 576px) {
  .typography-line span {
    width: 70px;
    margin-left: 5px;
  }
}

.offline-doc .page-header:before {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: block;
  left: 0;
  top: 0;
  content: "";
  background: rgba(0, 0, 0, .5);
}

#tsparticles {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  z-index: 0; /* if you use -1 you have to set to \`"window"\` the interactivity.detectsOn property */
}

.border-2 {
  border-width:2px !important;
}

.-space-x-3>:not([hidden])~:not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-3 img {
  box-sizing: content-box;
}

.MuiAutocomplete-listbox span, .MuiAutocomplete-listbox li, .react-tel-input .country-list .country {
  color: #01204c;
}
.MuiInputBase-root {
  color: #fff !important;
}
.react-tel-input .selected-flag {
  margin-top: 13px !important;
}
.react-tel-input label {
  margin-left: 40px !important;
}
.img-confesse {
  height: auto !important;
    width: 500px !important;
    max-width: none;
    margin-left: -100px;
}

.img-confie {
  width: 450px !important;
}

.confesse-page .confesse-title {
  position: absolute;
  top: 110px;
  left: 60px;
}

.confesse-page .confesse-description {
  margin-top: -30px;
  max-width: 450px;
  font-size: 0.875rem;
  line-height: 26px;
}
.divlogo {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/adicional/adicional.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,OAAO;EACP,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,aAAa;IACb,eAAe;IACf,YAAY;EACd;AACF;;AAEA,wBAAwB;;AAExB,qBAAqB;;AAErB;;;;;EAQE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kCAAkC;;AAElC;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE;;AAEF;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,OAAO;EACP,MAAM;EACN,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,UAAU;EACV,SAAS;EACT,UAAU,EAAE,qFAAqF;AACnG;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,wDAAwD;EACxD,iEAAiE;AACnE;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,uBAAuB;IACrB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,sBAAsB;AACxB","sourcesContent":[".tim-row {\n  margin-bottom: 20px;\n}\n\n.tim-white-buttons {\n  background-color: #777777;\n}\n\n.typography-line {\n  padding-left: 25%;\n  margin-bottom: 35px;\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.typography-line span {\n  bottom: 10px;\n  color: #c0c1c2;\n  display: block;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 13px;\n  left: 0;\n  margin-left: 20px;\n  position: absolute;\n  width: 260px;\n  text-transform: none;\n}\n\n.tim-row {\n  padding-top: 60px;\n}\n\n.tim-row h3 {\n  margin-top: 0;\n}\n\n.switch {\n  margin-right: 20px;\n}\n\n#navbar-full .navbar {\n  border-radius: 0 !important;\n  margin-bottom: 15px;\n  z-index: 2;\n}\n\n#menu-dropdown .navbar {\n  border-radius: 3px;\n}\n\n#pagination-row .pagination-container {\n  height: 100%;\n  max-height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n#icons-row i.now-ui-icons {\n  font-size: 30px;\n}\n\n.space {\n  height: 130px;\n  display: block;\n}\n\n.space-110 {\n  height: 110px;\n  display: block;\n}\n\n.space-50 {\n  height: 50px;\n  display: block;\n}\n\n.space-70 {\n  height: 70px;\n  display: block;\n}\n\n.navigation-example .img-src {\n  background-attachment: scroll;\n}\n\n.navigation-example {\n  background-position: center center;\n  background-size: cover;\n  margin-top: 0;\n  min-height: 740px;\n  height: 100%;\n}\n\n#notifications {\n  display: block;\n  width: 100%;\n  position: relative;\n}\n\n.tim-note {\n  text-transform: capitalize;\n}\n\n#buttons .btn,\n#javascriptComponents .btn {\n  margin: 0 0px 10px;\n  margin-right: 4px;\n}\n\n.space-100 {\n  height: 100px;\n  display: block;\n  width: 100%;\n}\n\n.be-social {\n  padding-bottom: 20px;\n  /*     border-bottom: 1px solid #aaa; */\n  margin: 0 auto 40px;\n}\n\n.txt-white {\n  color: #FFFFFF;\n}\n\n.txt-gray {\n  color: #ddd !important;\n}\n\n.parallax {\n  width: 100%;\n  height: 570px;\n  display: block;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n}\n\n.logo-container .logo {\n  overflow: hidden;\n  border-radius: 50%;\n  border: 1px solid #333333;\n  width: 50px;\n  float: left;\n}\n\n.logo-container .brand {\n  font-size: 16px;\n  color: #FFFFFF;\n  line-height: 18px;\n  float: left;\n  margin-left: 10px;\n  margin-top: 7px;\n  width: 70px;\n  height: 40px;\n  text-align: left;\n}\n\n.logo-container .brand-material {\n  font-size: 18px;\n  margin-top: 15px;\n  height: 25px;\n  width: auto;\n}\n\n.logo-container .logo img {\n  width: 100%;\n}\n\n.navbar-small .logo-container .brand {\n  color: #333333;\n}\n\n.fixed-section {\n  top: 90px;\n  max-height: 80vh;\n  overflow: scroll;\n  position: sticky;\n}\n\n.fixed-section ul {\n  padding: 0;\n}\n\n.fixed-section ul li {\n  list-style: none;\n}\n\n.fixed-section li a {\n  font-size: 14px;\n  padding: 2px;\n  display: block;\n  color: #666666;\n}\n\n.fixed-section li a.active {\n  color: #00bbff;\n}\n\n.fixed-section.float {\n  position: fixed;\n  top: 100px;\n  width: 200px;\n  margin-top: 0;\n}\n\n.parallax .parallax-image {\n  width: 100%;\n  overflow: hidden;\n  position: absolute;\n}\n\n.parallax .parallax-image img {\n  width: 100%;\n}\n\n@media (max-width: 768px) {\n  .parallax .parallax-image {\n    width: 100%;\n    height: 640px;\n    overflow: hidden;\n  }\n  .parallax .parallax-image img {\n    height: 100%;\n    width: auto;\n  }\n}\n\n/*.separator{\n    content: \"Separator\";\n    color: #FFFFFF;\n    display: block;\n    width: 100%;\n    padding: 20px;\n}\n.separator-line{\n    background-color: #EEE;\n    height: 1px;\n    width: 100%;\n    display: block;\n}\n.separator.separator-gray{\n    background-color: #EEEEEE;\n}*/\n\n.social-buttons-demo .btn {\n  margin-right: 5px;\n  margin-bottom: 7px;\n}\n\n.img-container {\n  width: 100%;\n  overflow: hidden;\n}\n\n.img-container img {\n  width: 100%;\n}\n\n.lightbox img {\n  width: 100%;\n}\n\n.lightbox .modal-content {\n  overflow: hidden;\n}\n\n.lightbox .modal-body {\n  padding: 0;\n}\n\n@media screen and (min-width: 991px) {\n  .lightbox .modal-dialog {\n    width: 960px;\n  }\n}\n\n@media (max-width: 991px) {\n  .fixed-section.affix {\n    position: relative;\n    margin-bottom: 100px;\n  }\n}\n\n@media (max-width: 768px) {\n  .btn,\n  .btn-morphing {\n    margin-bottom: 10px;\n  }\n  .parallax .motto {\n    top: 170px;\n    margin-top: 0;\n    font-size: 60px;\n    width: 270px;\n  }\n}\n\n/*       Loading dots  */\n\n/*      transitions */\n\n.presentation .front,\n.presentation .front:after,\n.presentation .front .btn,\n.logo-container .logo,\n.logo-container .brand {\n  -webkit-transition: all .2s;\n  -moz-transition: all .2s;\n  -o-transition: all .2s;\n  transition: all .2s;\n}\n\n#images h4 {\n  margin-bottom: 30px;\n}\n\n#javascriptComponents {\n  padding-bottom: 0;\n}\n\n/*      layer animation          */\n\n.layers-container {\n  display: block;\n  margin-top: 50px;\n  position: relative;\n}\n\n.layers-container img {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  top: 0;\n  left: 0;\n  text-align: center;\n}\n\n.animate {\n  transition: 1.5s ease-in-out;\n  -moz-transition: 1.5s ease-in-out;\n  -webkit-transition: 1.5s ease-in-out;\n}\n\n.navbar-default.navbar-small .logo-container .brand {\n  color: #333333;\n}\n\n.navbar-transparent.navbar-small .logo-container .brand {\n  color: #FFFFFF;\n}\n\n.navbar-default.navbar-small .logo-container .brand {\n  color: #333333;\n}\n\n.sharing-area {\n  margin-top: 80px;\n}\n\n.sharing-area .btn {\n  margin: 15px 4px 0;\n}\n\n.section-thin,\n.section-notifications {\n  padding: 0;\n}\n\n/*.section-navbars{\n    padding-top: 0;\n}*/\n\n#navbar .navbar {\n  margin-bottom: 20px;\n  z-index: 1 !important;\n}\n\n#navbar .navbar-toggler,\n#menu-dropdown .navbar-toggler {\n  pointer-events: none;\n}\n\n.section-pagination {\n  padding-bottom: 0;\n}\n\n.section-pagination .pagination:last-of-type {\n  margin-bottom: 7px;\n}\n\n.section-download {\n  padding-top: 130px;\n}\n\n.section-download .description {\n  margin-bottom: 60px;\n}\n\n.section-download h4 {\n  margin-bottom: 25px;\n}\n\n.section-examples a {\n  text-decoration: none;\n}\n\n.section-examples a+a {\n  margin-top: 30px;\n}\n\n.section-examples h5 {\n  margin-top: 30px;\n}\n\n.components-page .wrapper>.header,\n.tutorial-page .wrapper>.header {\n  height: 500px;\n  padding-top: 128px;\n  background-size: cover;\n  background-position: center center;\n}\n\n.components-page .title,\n.tutorial-page .title {\n  color: #FFFFFF;\n}\n\n.brand .h1-seo {\n  font-size: 5em;\n  text-transform: uppercase;\n  font-weight: 300;\n}\n\n.brand .n-logo {\n  max-width: 100px;\n  margin-bottom: 40px;\n}\n\n.invision-logo {\n  max-width: 70px;\n  top: -2px;\n  position: relative;\n}\n\n.creative-tim-logo {\n  max-width: 140px;\n  top: -2px;\n  position: relative;\n}\n\n.section-javascript .title {\n  margin-bottom: 0;\n}\n\n.navbar .switch-background {\n  display: block;\n}\n\n.navbar-transparent .switch-background {\n  display: none;\n}\n\n.section-signup .col .btn {\n  margin-top: 30px;\n}\n\n#buttons-row .btn {\n  margin-bottom: 10px;\n}\n\n.section-images {\n  padding-bottom: 0;\n}\n\n@media screen and (max-width: 991px) {\n  .section-navbars .navbar-collapse {\n    display: none !important;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .typography-line span {\n    width: 70px;\n    margin-left: 5px;\n  }\n}\n\n.offline-doc .page-header:before {\n  position: absolute;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  display: block;\n  left: 0;\n  top: 0;\n  content: \"\";\n  background: rgba(0, 0, 0, .5);\n}\n\n#tsparticles {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  margin: 0;\n  z-index: 0; /* if you use -1 you have to set to `\"window\"` the interactivity.detectsOn property */\n}\n\n.border-2 {\n  border-width:2px !important;\n}\n\n.-space-x-3>:not([hidden])~:not([hidden]) {\n  --tw-space-x-reverse: 0;\n  margin-right: calc(-0.75rem * var(--tw-space-x-reverse));\n  margin-left: calc(-0.75rem * calc(1 - var(--tw-space-x-reverse)));\n}\n.-space-x-3 img {\n  box-sizing: content-box;\n}\n\n.MuiAutocomplete-listbox span, .MuiAutocomplete-listbox li, .react-tel-input .country-list .country {\n  color: #01204c;\n}\n.MuiInputBase-root {\n  color: #fff !important;\n}\n.react-tel-input .selected-flag {\n  margin-top: 13px !important;\n}\n.react-tel-input label {\n  margin-left: 40px !important;\n}\n.img-confesse {\n  height: auto !important;\n    width: 500px !important;\n    max-width: none;\n    margin-left: -100px;\n}\n\n.img-confie {\n  width: 450px !important;\n}\n\n.confesse-page .confesse-title {\n  position: absolute;\n  top: 110px;\n  left: 60px;\n}\n\n.confesse-page .confesse-description {\n  margin-top: -30px;\n  max-width: 450px;\n  font-size: 0.875rem;\n  line-height: 26px;\n}\n.divlogo {\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
